// Product Collapsible Content → Tabs
// Transforms the Collapsible content section on product pages into
// a horizontal tab UI. Styles are injected via JS to keep everything
// in this single file. Only the script tag in collapsible-content.liquid
// is outside this file.
//
// To disable: remove the script tag from sections/collapsible-content.liquid
// ─────────────────────────────────────────────────────────────────────

(function () {

  // ── Styles ──────────────────────────────────────────────────────────────
  const css = `
     .product-tabs__nav {
      display: flex;
      flex-wrap: wrap;
      gap: 0;
      border-bottom: 0.15rem solid rgba(0, 0, 0, 0.75);
      margin-bottom: 2rem;
    }
    .product-tabs__btn {
      background: none;
      border: none;
      border-bottom: 0.2rem solid transparent;
      padding: 1rem 1.6rem;
      cursor: pointer;
      font-family: inherit;
      font-size: 1.8rem;
      color: rgba(var(--color-foreground), 0.6);
      margin-bottom: -0.1rem;
      transition: color 0.2s, border-color 0.2s;
      white-space: nowrap;
    }
    .product-tabs__btn:hover {
      color: rgb(var(--color-foreground));
    }
    .product-tabs__btn--active {
      color: rgb(var(--color-foreground));
      border-bottom: none;
      position: relative;
    }
    .product-tabs__btn--active::after {
      content: '';
      position: absolute;
      bottom: -0.25rem;
      left: 0.8rem;
      right: 0.8rem;
      height: 0.5rem;
      background: rgba(0, 0, 0, 0.75);
      border-radius: 4px;
    }
    .product-tabs__panel {
      display: none;
    }
    .product-tabs__panel--active {
      display: block;
    }
    .product-tabs__wrapper summary {
      display: none;
    }
    .product-tabs__wrapper details {
      display: block;
    }
    .product-tabs__wrapper .accordion__content {
      display: block !important;
      padding-top: 0;
    }
    .product-tabs__wrapper {
      width: 100%;
    }
    .product-tabs__panel img {
      max-width: 60% !important;
      height: auto !important;
      width: auto !important;
      display: block;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 2rem;
    }
    .product-tabs__panel iframe.responsive-video {
    width: 100% !important;
    max-width: 560px;
    height: auto;
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2rem;
    }
  `;

  const style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  // ── Tab builder ──────────────────────────────────────────────────────────
  function buildTabs(grid) {
    const detailsEls = Array.from(grid.querySelectorAll('details'));

    if (detailsEls.length < 2) return;

    const uid = Date.now();

    const wrapper = document.createElement('div');
    wrapper.className = 'product-tabs__wrapper';

    const nav = document.createElement('div');
    nav.className = 'product-tabs__nav';
    nav.setAttribute('role', 'tablist');

    const panels = detailsEls.map((details, i) => {
      const summary = details.querySelector('summary');
      const heading = summary ? summary.querySelector('.accordion__title') : null;
      const label = heading ? heading.textContent.trim() : (summary ? summary.textContent.trim() : 'Tab ' + (i + 1));

      const panelId = 'product-tab-panel-' + uid + '-' + i;
      const btnId   = 'product-tab-btn-'   + uid + '-' + i;

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product-tabs__btn' + (i === 0 ? ' product-tabs__btn--active' : '');
      btn.textContent = label;
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      btn.setAttribute('aria-controls', panelId);
      btn.id = btnId;
      nav.appendChild(btn);

      const panel = document.createElement('div');
      panel.className = 'product-tabs__panel' + (i === 0 ? ' product-tabs__panel--active' : '');
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', btnId);
      panel.id = panelId;
      details.open = true;
      panel.appendChild(details);

      return { btn, panel };
    });

    panels.forEach(({ btn }, i) => {
      btn.addEventListener('click', () => {
        panels.forEach(({ btn: b, panel: p }, j) => {
          const active = j === i;
          b.classList.toggle('product-tabs__btn--active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
          p.classList.toggle('product-tabs__panel--active', active);
        });
      });
    });

    wrapper.appendChild(nav);
    panels.forEach(({ panel }) => wrapper.appendChild(panel));
    grid.replaceChildren(wrapper);
  }

  // ── Init ─────────────────────────────────────────────────────────────────
  function init() {
    if (window.innerWidth < 750) return;
    document.querySelectorAll('.collapsible-content__grid').forEach(buildTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();